import Vue from 'vue'
import Router from 'vue-router'
import login from '@/login'
import word from '@/speech/index'
import speech from '@/speech/speech'
import type from '@/speech/type'
import vip from '@/speech/vip'
import user from '@/speech/user'
import exam from '@/speech/exam'
import examType from '@/speech/examType'
import feedback from '@/speech/feedback'
import info from '@/user/info'
import order from '@/user/order'
import speechList from '@/user/list'
import pkgList from '@/speech/pkgList'
import agreement from '@/mobile/agreement'
import wordIndex from '@/word/index'
import clockIndex from '@/clock/index'
import withdraw from '@/user/withdraw'
import codeList from '@/code/list'
import code from '@/mobile/code'
import evaluate from '@/evaluate/index'
import badge from '@/badge/index'
import level from '@/level/index'
import vipBuy from '@/mobile/vipBuy'
import promptIndex from '@/prompt/index'
import coursetIndex from '@/course/index'
import breakthrough from '@/breakthrough/index'
import pointsList from '@/points/index'
import readIndex from '@/read/index'
import sceneIndex from '@/scene/index'
import updateIndex from '@/update/index'

Vue.use(Router)

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta:{
        title:'登录'
      }
    },
    {
      path: '/word',
      name: 'word',
      component: word,
      meta:{
        title:'每日一词'
      }
    },
    {
      path: '/speech',
      name: 'speech',
      component: speech,
      meta:{
        title:'演讲管理'
      }
    },
    {
      path: '/type',
      name: 'type',
      component: type,
      meta:{
        title:'类型管理'
      }
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta:{
        title:'会员管理'
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
      meta:{
        title:'协议'
      }
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta:{
        title:'数字人管理'
      }
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam,
      meta:{
        title:'练习管理'
      }
    },
    {
      path: '/examType',
      name: 'examType',
      component: examType,
      meta:{
        title:'练习类型管理'
      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback,
      meta:{
        title:'用户反馈'
      }
    },
    {
      path: '/info',
      name: 'info',
      component: info,
      meta:{
        title:'用户信息'
      }
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      meta:{
        title:'订单管理'
      }
    },
    {
      path: '/pkgList',
      name: 'pkgList',
      component: pkgList,
      meta:{
        title:'加量包'
      }
    },
    {
      path: '/wordIndex',
      name: 'wordIndex',
      component: wordIndex,
      meta:{
        title:'词库管理'
      }
    },
    {
      path: '/clockIndex',
      name: 'clockIndex',
      component: clockIndex,
      meta:{
        title:'打卡管理'
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: withdraw,
      meta:{
        title:'提现列表'
      }
    },
    {
      path: '/codeList',
      name: 'codeList',
      component: codeList,
      meta:{
        title:'核销码列表'
      }
    },
    {
      path: '/code',
      name: 'code',
      component: code,
      meta:{
        title:'兑换码'
      }
    },
    {
      path: '/evaluate',
      name: 'evaluate',
      component: evaluate,
      meta:{
        title:'评估管理'
      }
    },
    {
      path: '/badge',
      name: 'badge',
      component: badge,
      meta:{
        title:'徽章管理'
      }
    },
    {
      path: '/level',
      name: 'level',
      component: level,
      meta:{
        title:'等级管理'
      }
    },
    {
      path: '/vipBuy',
      name: 'vipBuy',
      component: vipBuy,
      meta:{
        title:'头马会员'
      }
    },
    {
      path: '/promptIndex',
      name: 'promptIndex',
      component: promptIndex,
      meta:{
        title:'AI提示词'
      }
    },
    {
      path: '/coursetIndex',
      name: 'coursetIndex',
      component: coursetIndex,
      meta:{
        title:'课程管理'
      }
    },
    {
      path: '/breakthrough',
      name: 'breakthrough',
      component: breakthrough,
      meta:{
        title:'闯关挑战'
      }
    },
    {
      path: '/pointsList',
      name: 'pointsList',
      component: pointsList,
      meta:{
        title:'积分管理'
      }
    },
    {
      path: '/readIndex',
      name: 'readIndex',
      component: readIndex,
      meta:{
        title:'读稿管理'
      }
    },
    {
      path: '/sceneIndex',
      name: 'sceneIndex',
      component: sceneIndex,
      meta:{
        title:'场景管理'
      }
    },
    {
      path: '/updateIndex',
      name: 'updateIndex',
      component: updateIndex,
      meta:{
        title:'更新管理'
      }
    },
    {
      path: '/speechList',
      name: 'speechList',
      component: speechList,
      meta:{
        title:'演讲记录'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js